import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from '../../../../common/loading-overlay';

import styles from './image-viewer.module.scss';

const ImageViewer = (props) => {
	const [drawingView, setDrawingView] = props.drawingView;
	const [replacementImage, setReplacemntImage] = useState(null);

	useEffect(() => {
		if (props?.currentDrawing?.url?.includes('3908809906') || props?.currentDrawing?.url?.includes('2089575639')) {
			setReplacemntImage(props?.unavailableImage?.url);
		} else {
			setReplacemntImage(null);
		}
	}, [props?.currentDrawing?.url, props?.unavailableImage?.url]);

	useEffect(() => {
		if (props.currentDrawing?.display_name) setDrawingView(props.currentDrawing.display_name.toLowerCase());
		// eslint-disable-next-line react-hooks/exhaustive-deps -- fix later
	}, [props.currentDrawing?.display_name]);

	const onDrawingViewClick = (event, view) => {
		event.preventDefault();
		setDrawingView(view);
	};

	return (
		<>
			{props.updatingDrawing && (
				<LoadingOverlay
					className={`${styles.imageViewer_Loader} image-viewer-loader`}
					fixed={false}
				/>
			)}

			{!props.currentDrawing && (
				<div
					style={{
						width: props.drawingSize,
						height: props.drawingSize,
					}}
				/>
			)}

			{props.currentDrawing && (
				<img
					className={`${styles.imageViewer_Image} mb-5 md:mb-8`}
					src={replacementImage === null ? props.currentDrawing.url : replacementImage}
					alt={props.currentDrawing.display_name || 'interior'}
					title={props.currentDrawing.display_name}
					width={props.drawingSize}
					height={props.drawingSize}
					{...(props?.unavailableImage?.url
						? {
								onError: (event) => {
									event.target.onerror = '';
									event.target.src = props.unavailableImage.url;
									return true;
								},
							}
						: {})}
				/>
			)}

			{props.imageDisclaimer != null && (
				<div
					className='text-xs md:mx-auto md:text-sm'
					dangerouslySetInnerHTML={{ __html: props.imageDisclaimer }}
				/>
			)}

			{props.drawings?.available_drawings?.length > 1 && props.currentDrawing?.details_id && (
				<div className={`${styles.imageViewer_ButtonWrapper} flex flex-row flex-wrap p-1 text-center md:mb-5`}>
					<button
						onClick={(event) => onDrawingViewClick(event, 'interior')}
						className={`${drawingView !== 'exterior' ? styles.drawingActive : null} p-1 font-semibold`}
					>
						Interior View
					</button>
					<button
						onClick={(event) => onDrawingViewClick(event, 'exterior')}
						className={`${drawingView === 'exterior' ? styles.drawingActive : null} p-1 font-semibold`}
					>
						Exterior View
					</button>
				</div>
			)}
		</>
	);
};

ImageViewer.propTypes = {
	drawingSize: PropTypes.number,
	currentDrawing: PropTypes.object,
	drawings: PropTypes.object,
	className: PropTypes.string,
	drawingView: PropTypes.array,
	updatingDrawing: PropTypes.bool,
	imageDisclaimer: PropTypes.string,
	unavailableImage: PropTypes.object,
};

export default ImageViewer;
